import formatIsoDate from '@/services/general/formatIsoDate';
import cloneDeep from 'lodash/cloneDeep';

function formatAffectationsReseauFace(produit) {
  const faces = produit.produitReseau.affectationsReseauFace;
  const result = [];
  faces.forEach(item => {
    const faceAffectation = {
      dateDebut: formatIsoDate(item.dateDebut),
      dateFin: formatIsoDate(item.dateFin),
      produitId: item.produit.id,
      reseauFaceTags: item.reseauFaceTags?.map((rft) => {
        return {
          id: rft.id,
          tagId: rft.tagId,
        };
      }),
    };
    if (item.id) {
      faceAffectation.id = item.id;
    }
    result.push(faceAffectation);
  });
  return result;
}

export default function prepareSaveReseau(produitToSave) {
  const produit = cloneDeep(produitToSave);
  produit.produitReseau.dateDebut = formatIsoDate(produit.produitReseau.dateDebut);
  produit.produitReseau.dateFin = formatIsoDate(produit.produitReseau.dateFin);
  produit.produitReseau.affectationsReseauFace = formatAffectationsReseauFace(produit);
  produit.liaisonsTarif.forEach(item => {
    item.dateDebut = formatIsoDate(item.dateDebut);
    item.dateFin = formatIsoDate(item.dateFin);
  });
  if (produit.liaisonsTarif.length === 1 && (!produit.liaisonsTarif[0].produitEnfantId)) {
    produit.liaisonsTarif = [];
  }
  return produit;
}
